// src/Pages/PharmacistDashboard/PrescriptionManagement.js

import React, { useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  Paper,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Button,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Notifications as NotificationsIcon,
  FilterList as FilterIcon,
  Info as InfoIcon,
} from '@mui/icons-material';
import { prescriptionMockData } from '../../data/pharmacistPrescriptionManagementMockData';

const PrescriptionManagement = () => {
  const [prescriptions, setPrescriptions] = useState(prescriptionMockData);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterDoctor, setFilterDoctor] = useState('');
  const [filterStatus, setFilterStatus] = useState('');

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleFilterDoctorChange = (event) => {
    setFilterDoctor(event.target.value);
  };

  const handleFilterStatusChange = (event) => {
    setFilterStatus(event.target.value);
  };

  const handleFillPrescription = (id) => {
    setPrescriptions((prev) =>
      prev.map((prescription) =>
        prescription.id === id
          ? { ...prescription, status: 'Filled' }
          : prescription
      )
    );
  };

  const filteredPrescriptions = prescriptions.filter(
    (prescription) =>
      (prescription.patient.toLowerCase().includes(searchTerm.toLowerCase()) ||
        prescription.doctor.toLowerCase().includes(searchTerm.toLowerCase())) &&
      (filterDoctor ? prescription.doctor === filterDoctor : true) &&
      (filterStatus ? prescription.status === filterStatus : true)
  );

  return (
    <Box sx={{ padding: 2 }}>
      <Typography variant='h4' gutterBottom>
        Prescription Management
      </Typography>

      {/* Search and Filters */}
      <Grid container spacing={3} sx={{ marginBottom: 4 }}>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label='Search by Patient or Doctor'
            variant='outlined'
            value={searchTerm}
            onChange={handleSearchChange}
            InputProps={{
              endAdornment: <FilterIcon />,
            }}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <FormControl fullWidth>
            <InputLabel>Filter by Doctor</InputLabel>
            <Select
              value={filterDoctor}
              onChange={handleFilterDoctorChange}
              label='Filter by Doctor'
            >
              <MenuItem value=''>All Doctors</MenuItem>
              <MenuItem value='Dr. Arvind Kumar'>Dr. Arvind Kumar</MenuItem>
              <MenuItem value='Dr. Suresh Choudhury'>
                Dr. Suresh Choudhury
              </MenuItem>
              <MenuItem value='Dr. Dipankar Deka'>Dr. Dipankar Deka</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={4}>
          <FormControl fullWidth>
            <InputLabel>Filter by Status</InputLabel>
            <Select
              value={filterStatus}
              onChange={handleFilterStatusChange}
              label='Filter by Status'
            >
              <MenuItem value=''>All Statuses</MenuItem>
              <MenuItem value='Pending'>Pending</MenuItem>
              <MenuItem value='Filled'>Filled</MenuItem>
              <MenuItem value='Expired'>Expired</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      {/* Prescription List */}
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant='h6'>All Prescriptions</Typography>
          <Paper
            elevation={3}
            sx={{ padding: 2, maxHeight: 400, overflow: 'auto' }}
          >
            <List>
              {filteredPrescriptions.map((prescription) => (
                <ListItem
                  key={prescription.id}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <ListItemText
                    primary={`Patient: ${prescription.patient}`}
                    secondary={`Medication: ${prescription.medication} | Doctor: ${prescription.doctor} | Status: ${prescription.status}`}
                  />
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button
                      variant='contained'
                      color='primary'
                      startIcon={<CheckCircleIcon />}
                      onClick={() => handleFillPrescription(prescription.id)}
                      disabled={prescription.status === 'Filled'}
                    >
                      {prescription.status === 'Filled'
                        ? 'Filled'
                        : 'Mark as Filled'}
                    </Button>
                    <Button
                      variant='outlined'
                      color='secondary'
                      startIcon={<NotificationsIcon />}
                    >
                      Notify Patient
                    </Button>
                    <Button
                      variant='outlined'
                      color='info'
                      startIcon={<InfoIcon />}
                    >
                      View Details
                    </Button>
                  </Box>
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PrescriptionManagement;
